import { HttpClient, HttpEvent } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import { TSystemCultures, TOwnerSettings, IOwnerCulture } from '../entities/settings.model';
import { ICertificate, ICredentials, INFSe, ISettingsData } from '../entities/settings.interface';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl;

  public getOwnerCulture(): Observable<IOwnerCulture> {
    return this.http.get<IOwnerCulture>(this.apiUrl.account_service + `/SettingsOptions/GetOwnerCulture`, {
      withCredentials: true
    });
  }

  public getOwnerSettings(): Observable<TOwnerSettings> {
    return this.http.get<TOwnerSettings>(`${this.apiUrl.account_service}/OwnerSettings/GetAsync`, {
        withCredentials: true,
      });
  }

  public updateOwnerSettings(adjust: Partial<TOwnerSettings>): Observable<TOwnerSettings> {
    return this.http.patch<TOwnerSettings>(`${this.apiUrl.account_service}/OwnerSettings/UpdateRegionalSettings`, adjust, {
      withCredentials: true,
    });
  }

  public updateOwnerSettingsGeneral(adjust: Partial<TOwnerSettings>): Observable<TOwnerSettings> {
    return this.http.patch<TOwnerSettings>(`${this.apiUrl.account_service}/OwnerSettings`, adjust, {
      withCredentials: true,
    });
  }

  public getSystemTimeZones(): Observable<Record<string, string>> {
    return this.http.get<Record<string, string>>(this.apiUrl.account_service + `/SettingsOptions/GetSystemTimeZones`, {
      withCredentials: true
    })
  }

  public getSystemCultures(): Observable<TSystemCultures[]> {
    return this.http.get<TSystemCultures[]>(this.apiUrl.account_service + `/SettingsOptions/GetSystemCultures`, {
      withCredentials: true
    })
  }

  public getCredentialsByTenantId(tenantId: string): Observable<ICredentials> {
    return this.http.get<ICredentials>(this.apiUrl.invoicer + `/Security`, {
      params: { id: tenantId },
      withCredentials: true
    })
  }

  public updateCredentials(data: Partial<ICredentials>): Observable<ICredentials> {
    return this.http.patch<ICredentials>(this.apiUrl.invoicer + `/Security`, data, { withCredentials: true });
  }

  public createCertificate(data: Partial<ICertificate>): Observable<HttpEvent<ICertificate>> {
    return this.http.post<ICertificate>(this.apiUrl.account_service + `/CertificateArchive`, data, {
      withCredentials: true,
      observe: 'events',
      reportProgress: true
    });
  }

  public updateCertificate(data: Partial<ICertificate>): Observable<ICertificate> {
    return this.http.patch<ICertificate>(this.apiUrl.account_service + `/CertificateArchive`, data, { withCredentials: true });
  }

  public getNFSeByTenantId(tenantId: string): Observable<INFSe> {
    return this.http.get<INFSe>(this.apiUrl.invoicer + `/Configuration`, {
      params: { id: tenantId },
      withCredentials: true
    })
  }

  public updateNFSe(data: Partial<INFSe>): Observable<INFSe> {
    return this.http.patch<INFSe>(this.apiUrl.invoicer + `/Configuration`, data, { withCredentials: true });
  }
}
